import React from 'react';
const nraSafetyRules = ['ALWAYS keep the gun pointed in a safe direction.', 'ALWAYS keep your finger off the trigger until ready to shoot.', 'ALWAYS keep the gun unloaded until ready to use.'];
export function NRASafetyRules() {
  return <div className="w-full" style={{
    backgroundColor: '#f8f6f0'
  }} data-id="element-2905">
      <div className="max-w-4xl mx-auto px-4 md:px-8 pt-12" data-id="element-2906">
        <h2 className="text-2xl md:text-3xl font-bold uppercase mb-6" style={{
        fontFamily: 'Oswald, sans-serif',
        color: '#1e3d2f'
      }} data-id="element-2907">
          NRA Fundamental Safety Rules
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-2908">
          {nraSafetyRules.map((rule, index) => <div key={index} className="bg-white rounded-xl p-6 shadow-sm border-2 flex flex-col items-center text-center" style={{
          borderColor: '#c8a84b'
        }} data-id="element-2909">
              <div className="w-12 h-12 rounded-full flex items-center justify-center mb-4 font-bold text-xl" style={{
            backgroundColor: '#1e3d2f',
            color: '#c8a84b',
            fontFamily: 'Oswald, sans-serif'
          }} data-id="element-2910">
                {index + 1}
              </div>
              <p className="text-base font-semibold text-gray-900" style={{
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-2911">
                {rule}
              </p>
            </div>)}
        </div>
      </div>
    </div>;
}